import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EquipmentStore from 'stores/EquipmentStore';
import SessionStore from 'stores/SessionStore';
import { equipmentTypesMapping } from 'constants/Equipment';
import EquipmentForm from './EquipmentForm';
export default class AddEquipmentForm extends Component {
    constructor(props) {
        super(props);
        this.handleSessionStoreChange = () => {
            const isAdmin = SessionStore.isAdmin();
            this.setState({
                isAdmin,
            });
        };
        this.handleStoreChange = () => {
            const formStatus = EquipmentStore.getFormStatus();
            if (!formStatus.success) {
                this.setState((prevState) => {
                    const error = Object.assign({}, prevState.error);
                    Object.keys(formStatus.error).forEach((key) => {
                        error[key] = formStatus.error[key];
                    });
                    return {
                        error,
                    };
                });
            }
        };
        this.handleChange = (field, value) => this.setState((currentState) => {
            const { equipment: currentEquipment } = currentState;
            const equipment = Object.assign(Object.assign({}, currentEquipment), { [field]: value });
            /**
             * Reset chassis_owner_type and chassis_owner if is_private is set to false.
             */
            const fieldResetRequiredWhenToggleOff = field === 'is_private' && !value;
            if (fieldResetRequiredWhenToggleOff) {
                equipment.chassis_owner_type = null;
                equipment.chassis_owner = null;
            }
            /**
             * Below fields are not part of trailer and container,
             * so reset to default whenever _equipmentType changes
             */
            const fieldResetRequiredForNotChassisType = field === '_equipmentType' && value !== equipmentTypesMapping.CHASSIS;
            if (fieldResetRequiredForNotChassisType) {
                equipment.chassis_owner_type = null;
                equipment.chassis_owner = null;
                equipment.is_private = false;
            }
            /**
             * Below fields are not part of chassis and trailer,
             * so reset to default whenever _equipmentType changed to chassis or trailer
             */
            const fieldResetRequiredForNotContainer = field === '_equipmentType' && value !== equipmentTypesMapping.CONTAINER;
            if (fieldResetRequiredForNotContainer) {
                equipment._equipmentSize = null;
                equipment._type = null;
            }
            return {
                equipment,
            };
        });
        this.handleSave = () => {
            const { equipment } = this.state;
            this.props.onSave(equipment);
        };
        this.handleCancel = () => {
            this.setState(getInitialState());
            this.props.onCancel();
        };
        this.state = Object.assign(Object.assign({}, getInitialState(props)), { isAdmin: SessionStore.isAdmin() });
    }
    componentDidMount() {
        EquipmentStore.addEquipmentFormListener(this.handleStoreChange);
        SessionStore.addChangeListener(this.handleSessionStoreChange);
    }
    componentWillUnmount() {
        EquipmentStore.removeEquipmentFormListener(this.handleStoreChange);
        SessionStore.removeChangeListener(this.handleSessionStoreChange);
    }
    render() {
        return (React.createElement(EquipmentForm, { equipment: this.state.equipment, error: this.state.error, onCancel: this.handleCancel, onFieldChange: this.handleChange, onSave: this.handleSave, isAdmin: this.state.isAdmin, isNew: true }));
    }
}
AddEquipmentForm.propTypes = {
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};
const getInitialState = (props) => {
    return {
        equipment: {
            equipment_id: props && props.equipmentId ? props.equipmentId : '',
            _equipmentType: 'container',
            _equipmentSize: '',
            _type: '',
            status: 'N/A',
        },
        error: {},
    };
};
